var Theme = {
    Light: 'light',
    Dark: 'dark',
};
var Brand = {
    Sports: 'superbet',
    Gaming: 'superbet-gaming',
    NapoleonSports: 'napoleon',
    NapoleonGaming: 'napoleon-gaming',
};

export { Brand, Theme };
